import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import {
  AI_deleteLeaveDate,
  AI_getLeaveDates,
  AI_getLeaveList,
  AI_getPendingLeaveList,
  AI_updateLeaveDates,
  AI_updateLeaveStatus,
} from "APIs/leave";
import CommonButton from "components/common-component/Button";
import { useEffect, useState } from "react";
import { ReactComponent as DeleteIcon } from "assets/images/icons/DeleteIcon.svg";
import CommonToolTip from "components/common-component/Tooltip";
import { AI_getUserData } from "APIs/user";
import { useInstance } from "easy-redux-http-call";
import { useAIEventHandler } from "easy-redux-http-call";
import LeaveConfirmDialog from "./LeaveConfirmDialog";
import { useParams } from "react-router-dom";

import ConfirmEditDialog from "components/common-component/ConfirmEditDialog";
import moment from "moment";

const useStyle = makeStyles((theme) => ({
  dialog: {
    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
    width: "40%",
  },
  error: {
    marginTop: "-15px",
    color: "#ff4d4f",
    fontSize: "0.75rem",
    fontWeight: 400,
  },
  dateRangePicker: {
    "&>div": {
      width: "100%",
      "&>div": {
        width: "100%",
        "&>div": {
          width: "100%",
          margin: 0,
          padding: "10px",
        },
      },
    },
  },
  dialogTitle: {
    display: "flex",
    gap: "10px",
  },
  closeIconButton: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  leaveIcon: {
    marginRight: "10px",
    marginBottom: "-5px",
  },
  editContainer: {
    display: "flex",
    justifyContent: "end",
    gap: "10px",
    marginTop: "10px",
  },
  partialApproveButton: {
    display: "flex",
    justifyContent: "end",
  },
  cancelButton: {
    display: "flex",
    justifyContent: "end",
    gap: "10px",
    margin: "10px 0px",
  },
  chip: {
    borderRadius: "27px",
  },
  hrTitle: {
    textAlign: "left",
  },
  hrRadiobtn: {
    display: "grid",
    justifyItems: "center",
  },
  hrRejectRadio: {
    color: "red",
    "&.Mui-checked": {
      color: "red",
    },
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    width: "280%",
    height: "100px",
    alignItems: "center",
    margin: "15px 0px",
  },
}));

const ShowLeaveDates = ({
  openStatus = false,
  type = null,
  handleClose,
  leaveId = [],
  approverView,
  fetchLeaveData = () => {},
}) => {
  const classes = useStyle();
  const [isEdit, setIsEdit] = useState(false);
  const [leave, setLeave] = useState([]);
  const [payloadData, setPayloadData] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState({
    open: false,
    type: "",
  });

  // ConFirm Edit Modal to confirm "Save"
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const leaveDateLoading = useInstance(AI_updateLeaveStatus);
  const leaveDates = useInstance(AI_getLeaveDates);
  const getUserData = useInstance(AI_getUserData);

  const handelEdit = () => {
    setIsEdit(true);
  };
  const handleEditClose = () => {
    setIsEdit(false);
  };

  useEffect(() => {
    if (leaveId) {
      AI_getLeaveDates.call({
        urlParams: {
          id: leaveId,
        },
      });
    }
  }, [leaveId]);

  useEffect(() => {
    if (leaveDates.data) {
      setLeave(leaveDates.data);
    }
  }, [leaveDates]);

  const handleDateChange = (value, id) => {
    const temp = [...leave];
    const payload_data = [...leave];
    const findLeave = temp.find((obj) => obj.id === id);
    const findLeavePayload = payload_data.find((obj) => obj.id === id);

    if (findLeave) {
      findLeavePayload.approved_leave_type = value;
      findLeave.approved_leave_type
        ? (findLeave.approved_leave_type = value)
        : (findLeave.requested_leave_type = value);
    }
    const nullRows = temp.forEach((row) => {
      if (row.approved_leave_type === null) {
        row.approved_leave_type = row.requested_leave_type;
      }
    });
    setLeave(payload_data);
    setPayloadData([...payloadData, findLeavePayload]);
  };

  const handleUpdateDate = () => {
    setShowConfirmDialog(true);
    setIsEdit(false);
    // handleClose();
  };

  const handleDeleteDate = (id) => {
    AI_deleteLeaveDate.call({
      params: {
        id: id,
        leave_id: leave[0].leave_id,
      },
    });
  };

  const handleChangeLeaveStatus = (val) => {
    const temp = [...leave];
    if(val === "approved"){
      const nullRows = temp.forEach((row) => {
        if (row.approved_leave_type === null) {
          row.approved_leave_type = row.requested_leave_type;
        } else {
          row.approved_leave_type = row.requested_leave_type
        }
      });
    }
    if(val === "reject"){
      const rejectRows = temp.forEach((row) => {
        if (row.approved_leave_type === null) {
          row.approved_leave_type = "Reject";
        } else {
          row.approved_leave_type = "Reject";
        }
      });
    }
    AI_updateLeaveStatus.call({
      urlParams: {
        id: leave[0].leave_id,
      },
      params: {
        leave_status: val,
        leave_dates:
          val === "approved_with_changes"
            ? leave[0].approved_leave_type
              ? leave
              : payloadData
            : temp,
      },
    });
    fetchLeaveData();
  };

  const handleOpenConfirmDialog = (val) => {
    setOpenConfirmDialog({
      open: true,
      type: val,
    });
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog({
      open: false,
      type: "",
    });
  };
  useAIEventHandler(AI_updateLeaveStatus, {
    onSuccess: () => {
      AI_getLeaveDates.call({
        urlParams: {
          id: leave[0].leave_id,
        },
      });
      AI_getPendingLeaveList.call()
      handleEditClose();
      handleCloseConfirmDialog();
    },
  });

  const confirmEditAction = (status) => {

    if (status == true) {
      const fullDayLeaves = [];
      const firstHalf = [];
      const secondHalf = [];
      const temp = [...leave];
      temp.map((data) => {
        if (data.approved_leave_type === "fullday") {
          fullDayLeaves.push(data.id);
        } else if(data.approved_leave_type === "firstHalf") {
          firstHalf.push({
            requested_leave_type: data.approved_leave_type,
            id: data.id,
          });
        } else if(data.approved_leave_type === "secondHalf") {
          secondHalf.push({
            requested_leave_type: data.approved_leave_type,
            id: data.id,
          });
        }
      });

      AI_updateLeaveDates.call({
        params: {
          leave_id: leave[0].leave_id,
          fullDayLeaves: fullDayLeaves,
          firstHalf: firstHalf,
          secondHalf: secondHalf,
          is_admin: "",
        },
      });
    }
    setShowConfirmDialog(false);
  };

  useAIEventHandler(AI_deleteLeaveDate, {
    onSuccess: (val) => {
      if (val.data.is_last_leave) {
        handleClose();
      }
    },
  });

  useAIEventHandler(AI_updateLeaveDates, {
    onSuccess: (val) => {
      AI_getLeaveList.call({
        urlParams: {
          id: getUserData &&  getUserData?.data?.user?.employee_id ,
        },
      });
    },
  });
  return (
    <>
      <Dialog open={openStatus} classes={{ paper: classes.dialog }} fullWidth>
        <DialogTitle>
          <div className={classes.dialogTitle}>
            <CalendarMonthIcon />
            <Typography variant="h4" className={classes.hrTitle}>
              Dates
            </Typography>
          </div>
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            className={classes.closeIconButton}
            color="error"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <TableContainer>
            <Table
              size="small"
              aria-label="a dense table"
              className={classes.table}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ paddingLeft: "30px" }}>Date</TableCell>
                  {!isEdit ? (
                    <>
                      <TableCell style={{ paddingLeft: "30px" }}>
                        Requested
                      </TableCell>
                      <TableCell style={{ paddingLeft: "23px" }}>
                        Approved
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell>Full Day</TableCell>
                      <TableCell>First Half</TableCell>
                      <TableCell>Second Half</TableCell>
                      <TableCell>
                        {approverView ? "Reject" : "Delete"}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>
              {!leaveDates.loading ? (
                <TableBody>
                  {leave.map((leave) => (
                    <TableRow key={leave.id}>
                      <TableCell>
                        {moment(leave.date).format("DD MMMM yyyy")}
                      </TableCell>
                      {!isEdit ? (
                        <>
                          <TableCell className={classes.icons}>
                            {type === "leave" ? (
                              <Chip
                                className={classes.chip}
                                label={
                                  leave.requested_leave_type === "fullday"
                                    ? "Full-Day Leave"
                                    : leave.requested_leave_type === "firstHalf"
                                    ? "First Half Leave"
                                    : leave.requested_leave_type ===
                                      "secondHalf"
                                    ? "Second Half Leave"
                                    : ""
                                }
                                color="primary"
                                variant="contained"
                              />
                            ) : type === "extra" ? (
                              <Chip
                                className={classes.chip}
                                label={
                                  leave.requested_leave_type === "fullday"
                                    ? " Full Extra-Day"
                                    : leave.requested_leave_type === "firstHalf"
                                    ? "Extra First-Half"
                                    : leave.requested_leave_type ===
                                      "secondHalf"
                                    ? "Extra Second-Half"
                                    : ""
                                }
                                color="primary"
                                variant="contained"
                              />
                            ) : null}
                          </TableCell>
                          {leave.approved_leave_type !== null ? (
                            <TableCell className={classes.icons}>
                              {leave.approved_leave_type === "fullday" ? (
                                <Chip
                                  className={classes.chip}
                                  label={
                                    type === "leave"
                                      ? "Full-Day Leave"
                                      : "Full-Day Extra"
                                  }
                                  color="success"
                                  variant="outlined"
                                />
                              ) : leave.approved_leave_type === "firstHalf" ? (
                                <Chip
                                  className={classes.chip}
                                  label={
                                    // type === "leave"
                                    // ?
                                    // leave.approved_leave_type === "firstHalf" ?
                                    //     "First-Half"
                                    //     : "Second-Half"
                                    // : "Half Extra-day"
                                    type === "leave"
                                      ? "First-Half Leave"
                                      : "First-Half Extra "
                                  }
                                  color="success"
                                  variant="outlined"
                                />
                              ) : leave.approved_leave_type === "secondHalf" ? (
                                <Chip
                                  className={classes.chip}
                                  label={
                                    type === "leave"
                                      ? " Second-Half Leave"
                                      : " Second-Half Extra"
                                  }
                                  color="success"
                                  variant="outlined"
                                />
                              ) : (
                                <Chip
                                  className={classes.chip}
                                  label="Reject"
                                  color="error"
                                  variant="outlined"
                                />
                              )}
                            </TableCell>
                          ) : (
                            <TableCell className={classes.icons}>
                              <Chip
                                className={classes.chip}
                                label="Requested"
                                color="primary"
                                variant="outlined"
                              />
                            </TableCell>
                          )}
                        </>
                      ) : (
                        <>
                          <TableCell>
                            <FormControl className={classes.hrRadiobtn}>
                              <RadioGroup
                                row
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="leave"
                                value={
                                  leave.approved_leave_type
                                    ? leave.approved_leave_type
                                    : leave.requested_leave_type
                                }
                                onChange={(e) =>
                                  handleDateChange(e.target.value, leave.id)
                                }
                              >
                                <FormControlLabel
                                  value="fullday"
                                  control={<Radio value="fullday" />}
                                />
                              </RadioGroup>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            <FormControl className={classes.hrRadiobtn}>
                              <RadioGroup
                                row
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="leave"
                                value={
                                  leave.approved_leave_type
                                    ? leave.approved_leave_type
                                    : leave.requested_leave_type
                                }
                                onChange={(e) =>
                                  handleDateChange(e.target.value, leave.id)
                                }
                              >
                                <FormControlLabel
                                  value="firstHalf"
                                  control={<Radio value="firstHalf" />}
                                />
                              </RadioGroup>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            <FormControl className={classes.hrRadiobtn}>
                              <RadioGroup
                                row
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="leave"
                                value={
                                  leave.approved_leave_type
                                    ? leave.approved_leave_type
                                    : leave.requested_leave_type
                                }
                                onChange={(e) =>
                                  handleDateChange(e.target.value, leave.id)
                                }
                              >
                                <FormControlLabel
                                  value="secondHalf"
                                  control={<Radio value="secondHalf" />}
                                />
                              </RadioGroup>
                            </FormControl>
                          </TableCell>
                          <TableCell>
                            {approverView ? (
                              <RadioGroup
                                className={classes.hrRadiobtn}
                                row
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="Reject"
                                value={
                                  leave.approved_leave_type
                                    ? leave.approved_leave_type
                                    : leave.requested_leave_type
                                }
                                onChange={(e) =>
                                  handleDateChange(e.target.value, leave.id)
                                }
                              >
                                <FormControlLabel
                                  value="Reject"
                                  control={
                                    <Radio
                                      className={classes.hrRejectRadio}
                                      value="Reject"
                                    />
                                  }
                                />
                              </RadioGroup>
                            ) : (
                              <CommonToolTip title="Delete">
                                <IconButton
                                  onClick={() => handleDeleteDate(leave.id)}
                                  color="error"
                                >
                                  <DeleteIcon
                                    height={18}
                                    width={18}
                                    htmlcolor="red"
                                  />
                                </IconButton>
                              </CommonToolTip>
                            )}
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody className={classes.loading}>
                  {/* <Typography variant="h6" >
                Fetching data...
              </Typography> */}
                  Fetching data...
                </TableBody>
              )}
            </Table>
            {!isEdit && (
              <Grid className={classes.editContainer}>
                {!isEdit && (
                  <Grid className={classes.partialApproveButton}>
                    {approverView && (
                      <CommonButton onClick={() => handelEdit()}>
                        Partial Approve
                      </CommonButton>
                    )}
                    {!leave[0]?.approved_leave_type && !approverView && (
                      <CommonButton onClick={() => handelEdit()}>
                        Edit Leave
                      </CommonButton>
                    )}
                  </Grid>
                )}
                {approverView && (
                  <>
                    <CommonButton
                      onClick={() => handleOpenConfirmDialog("approved")}
                    >
                      Approve All
                    </CommonButton>
                    <CommonButton
                      onClick={() => handleOpenConfirmDialog("reject")}
                    >
                      Reject All
                    </CommonButton>
                  </>
                )}
              </Grid>
            )}
            {isEdit && (
              <Grid className={classes.cancelButton}>
                {" "}
                <CommonButton
                  onClick={() => handleEditClose()}
                  variant="outlined"
                >
                  Cancel
                </CommonButton>
                {approverView ? (
                  <CommonButton
                    onClick={() =>
                      handleChangeLeaveStatus("approved_with_changes")
                    }
                    loading={leaveDateLoading.loading}
                  >
                    Approve with changes
                  </CommonButton>
                ) : (
                  <CommonButton
                    onClick={() => handleUpdateDate()}
                    variant="contained"
                  >
                    Save
                  </CommonButton>
                )}
              </Grid>
            )}
          </TableContainer>
        </DialogContent>
      </Dialog>
      {openConfirmDialog.open && (
        <LeaveConfirmDialog
          open={openConfirmDialog.open}
          handleClose={handleCloseConfirmDialog}
          handeleSubmit={handleChangeLeaveStatus}
          approved={openConfirmDialog.type}
          loading={leaveDateLoading.loading}
        />
      )}
      {/* ConfirmEditDailog */}
      <ConfirmEditDialog
        openStatus={showConfirmDialog}
        confirmAction={confirmEditAction}
        confirmText={`Are you sure you want to Update the Leave ?`}
      />
    </>
  );
};

export default ShowLeaveDates;
